/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Naman's Portfolio",
  description:
    "Trailblazing autonomous systems engineer, adept in the fields of robotics, aerospace and deep learning, leveraging expertise to transform the future of transportation and automation.",
  og: {
    title: "Naman Rawal Portfolio",
    type: "website",
    url: "http://rawnam.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Naman Rawal",
  logo_name: "NamanRawal",
  nickname: "",
  subTitle:
    "Trailblazing autonomous systems engineer, adept in the fields of robotics, aerospace and deep learning, leveraging expertise to transform the future of transportation and automation.",
  resumeLink:
    "https://drive.google.com/file/d/1iv_M9YVlqry5TtAE1Rc_xyXnMpJta76z/view?usp=sharing",
  portfolio_repository: "https://github.com/rawnam/masterPortfolio",
  githubProfile: "https://github.com/rawnam",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/rawnam",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/naman-rawal/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:nam.kumar31@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/namovam",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/na.ku.ra/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Autonomous Systems",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building SAE Level 4 and 5 Automated Driving Systems",
        "⚡ Developing a scalable data collection platform integrating various sensor technologies on 2 Wheelers",
        "⚡ Experience in providing leadership and mentorship to a team of Robotics Engineers in the AV Team",
      ],
      softwareSkills: [
        {
          skillName: "ROS2",
          fontAwesomeClassname: "simple-icons:ros",
          style: {
            color: "#22314E",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#00599C",
          },
        },
      ],
    },
    {
      title: "Deep Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing and deploying end-to-end models such as OpenPilot, NEAT, Lift-Splat-Shoot, FIERY, STP3",
        "⚡ Experience in working with Graph Neural Networks for predicting social interactions in dense traffic",
        "⚡ Expertise in Uncertainty Estimation in Deep Learning",
      ],
      softwareSkills: [
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "CUDA",
          fontAwesomeClassname: "simple-icons:nvidia",
          style: {
            backgroundColor: "transparent",
            color: "#76B900",
          },
        },
      ],
    },
    {
      title: "Coding",
      fileName: "FullStackImg",
      skills: [
        "⚡ Proficient in C, C++11/14/17/20, Python, SysML, UML",
        "⚡ Experience in using middleware such as Robot Operating System (ROS/ROS2), micro-ROS, DDS, MQTT",
        "⚡ Familiarity with operating systems like Linux(Ubuntu, L4T), Linux RT-Preempt, Windows, Linux Redhat, VxWorks, QNX, DEOS",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#00599C",
          },
        },
        {
          skillName: "ROS",
          fontAwesomeClassname: "simple-icons:ros",
          style: {
            color: "#22314E",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
      ],
    },
  ],
};


// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/nakura404/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/skysfalling",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/nakura",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/rawnam",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@nam.kumar31",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/skysfalling",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Honeywell Leading Edge Program",
      subtitle: "Special Graduate Program for Leadership Development",
      logo_path: "honeywell_logo.png",
      alt_name: "Honeywell Leading Edge Program",
      duration: "2015-2017",
      descriptions: [
        "⚡ Participated in an advanced professional development program."
      ],
      website_link: "https://www.honeywell.com/",
    },
    {
      title: "Indian Institute of Technology, Kanpur",
      subtitle: "M.Tech., Aerospace Engineering",
      logo_path: "iitk_logo.png",
      alt_name: "IIT Kanpur",
      duration: "2014 - 2015",
      descriptions: [
        "⚡ Specialized in Helicopter Dynamics",
        "⚡ Undertook advanced coursework including Machine Learning, Autonomous Navigation, and Control Theory."
      ],
      website_link: "https://www.iitk.ac.in",
    },
    {
      title: "Indian Institute of Technology, Kanpur",
      subtitle: "B. Tech., Aerospace Engineering",
      logo_path: "iitk_logo.png",
      alt_name: "IIT Kanpur",
      duration: "2010 - 2014",
      descriptions: [
        "⚡ Obtained Bachelor of Technology in Aerospace Engineering.",
        "⚡ Studied essential engineering courses including Flight Mechanics, Aerodynamics, and Propulsion."
      ],
      website_link: "https://www.iitk.ac.in",
    }
  ],
};


const certifications = {
  certifications: [
    // {
    //   title: "Machine Learning",
    //   subtitle: "- Andrew Ng",
    //   logo_path: "stanford_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "Stanford University",
    //   color_code: "#8C151599",
    // },
    {
      title: "Deep Learning Specialization",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/285BGK5XKKB6",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Object Oriented Data Structures in C++",
      subtitle: "- University of Illinois at Urbana-Champaign",
      logo_path: "uiuc_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/8Q395QRR7FT4",
      alt_name: "UIUC",
      color_code: "#0C9D5899",
    },
    {
      title: "Build a Modern Computer from First Principles: From Nand to Tetris",
      subtitle: "- Hebrew University of Jerusalem",
      logo_path: "huj_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/KU8UZCVRD78D",
      alt_name: "HUJ",
      color_code: "#1F70C199",
    },
    {
      title: "Bayesian Methods for Machine Learning",
      subtitle: "- Higher School of Economics",
      logo_path: "hse_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/DAWEZT3MZB67",
      alt_name: "HSE",
      color_code: "#D83B0199",
    },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internships and Academic Projects",
  description:
    "With extensive experience in the autonomous systems, aerospace, and robotics sectors, I've held various leadership and engineering roles at Ola Electric and Honeywell Aerospace, driving advancements in autonomous driving technologies, sensor integration, and deep learning, as well as completing significant projects during internships at Airbus and Boeing.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Associate Director - Autonomous Systems",
          company: "Ola Electric",
          company_url: "https://olaelectric.com/",
          logo_path: "ola_logo.png",
          duration: "March 2023 - Present",
          location: "Bengaluru, Karnataka",
          description:
            "As an Associate Director at Ola Electric, I've led a team of robotics engineers in developing a scalable data collection platform and advanced end-to-end semi-supervised neural networks for real-time depth and collision prediction, with our rider assistance prototype deployed across 10 two-wheeler platforms for Indian contexts.",
          color: "#0879bf",
        },
        {
          title: "Systems Engineer - Autonomous Systems",
          company: "Ola Electric",
          company_url: "https://olaelectric.com/",
          logo_path: "ola_logo.png",
          duration: "April 2022 - March 2023",
          location: "Bengaluru, Karnataka",
          description:
            "At Ola Electric as Lead System Engineer, I spearheaded the development of a scalable data collection platform, established a software stack for Rider Assistance System, integrated advanced controls for Drive-by-Wire testing, and led a dynamic team of Robotics Engineers to innovate in autonomous driving and rider assistance for two-wheelers.",
          color: "#FFA07A",
        },
        {
          title: "Research Engineer II - Autonomous Systems",
          company: "Ola Electric",
          company_url: "https://olaelectric.com/",
          logo_path: "ola_logo.png",
          duration: "June 2021 - March 2022",
          location: "Bengaluru, Karnataka",
          description:
            "At Ola Electric, as a Senior Research Engineer, I spearheaded the development and certification strategies for learning-based Automated Driving Systems, crafted innovative solutions for dense traffic interactions, and contributed to winning a silver badge in the Google Decimeter Challenge 2022 on Kaggle, among other accomplishments.",
          color: "#00796B",
        },
        {
          title: "Advanced Embedded Engineer",
          company: "Honeywell Aerospace",
          company_url: "https://aerospace.honeywell.com",
          logo_path: "honeywell_logo.png",
          duration: "January 2020 - May 2021",
          location: "Bengaluru, Karnataka",
          description:
            "As an Advanced Embedded Engineer at Honeywell Aerospace, I led a team of 10 engineers, developed navigation and control systems for autonomous landing, integrated sensor fusion algorithms, and accelerated development through Unreal Engine simulations, while also developing requirements for Honeywell’s certifiable Alternate Navigation System.",
          color: "#9b1578",
        },
        {
          title: "Technical Lead",
          company: "Honeywell Aerospace",
          company_url: "https://aerospace.honeywell.com",
          logo_path: "honeywell_logo.png",
          duration: "October 2018 - December 2019",
          location: "Bengaluru, Karnataka",
          description:
            "As the Technical Lead at Honeywell Aerospace, I led a global team of engineers in developing innovative solutions, from conceiving novel spherical motor models to implementing magnetic field calibration for indoor navigation, while also embedding flight controls and integrating real-time object tracking with gimbal control.",
          color: "#A67FB5",
        },
        {
          title: "Senior Engineer",
          company: "Honeywell Aerospace",
          company_url: "https://aerospace.honeywell.com",
          logo_path: "honeywell_logo.png",
          duration: "July 2015 - October 2018",
          location: "Bengaluru, Karnataka",
          description:
            "As a Senior Engineer at Honeywell Aerospace, I innovated in control systems and robotic manipulators, developed energy-saving flight controls, and spearheaded the integration of real-time object tracking with gimbal control while managing embedded software development for certified autopilot systems.",
          color: "#5AC8FA",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Aerodata Intern",
          company: "Airbus",
          company_url: "https://www.airbus.com",
          logo_path: "airbus_logo.png",
          duration: "June 2013 - July 2013",
          location: "Bengaluru, Karnataka",
          description:
            "Developed a framework for automation of computational fluid dynamics analysis pipeline with optimized automation of large batches of aircraft geometries and aerodynamic conditions",
          color: "#000000",
        },
        {
          title: "Robotics Extern",
          company: "Boeing",
          company_url: "https://www.boeing.com/",
          logo_path: "boeing_logo.png",
          duration: "May 2011 - April 2013",
          location: "IIT Kanpur, India",
          description:
            "Designed a system of autonomous robots with capability to scan for gas leaks and jumping capabilities",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Academic Projects",
      experiences: [
        {
          title: "Autonomous Navigation",
          company: "IIT Kanpur",
          company_url: "https://www.iitk.ac.in",
          logo_path: "iitk_logo.png",
          duration: "Fall 2014",
          location: "IIT Kanpur, India",
          description:
            "3D Path Planning using Rapidly Exploring Random Trees",
          color: "#4285F4",
        },
        {
          title: "Autonomous Navigation",
          company: "IIT Kanpur",
          company_url: "https://www.iitk.ac.in",
          logo_path: "iitk_logo.png",
          duration: "Fall 2014",
          location: "IIT Kanpur, India",
          description:
            "Path Planning for a 2D multi-linkage robot using Probabilistic Roadmap Planner",
          color: "#D83B01",
        },
        {
          title: "Autonomous Navigation",
          company: "IIT Kanpur",
          company_url: "https://www.iitk.ac.in",
          logo_path: "iitk_logo.png",
          duration: "Fall 2014",
          location: "IIT Kanpur, India",
          description:
            "Cooperative Formation Control Strategy for a multi agent drone system",
          color: "#000000",
        },
        {
          title: "Computational Fluid Dynamics",
          company: "IIT Kanpur",
          company_url: "https://www.iitk.ac.in",
          logo_path: "iitk_logo.png",
          duration: "Fall 2012",
          location: "IIT Kanpur, India",
          description:
            "2D Mesh Generation for Finite Element Analysis using Delaunay Triangulation",
          color: "#0C9D58",
        },
        {
          title: "Computational Fluid Dynamics",
          company: "IIT Kanpur",
          company_url: "https://www.iitk.ac.in",
          logo_path: "iitk_logo.png",
          duration: "Fall 2012",
          location: "IIT Kanpur, India",
          description:
            "Analysis of Shape Memory Alloy coupled composite beam actuator for active airfoil camber control",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have worked on a wide range of projects in the field of Robotics, Artificial Intelligence, and Control Systems. My projects have been deployed across Aerospace and Automotive sectors and were granted patents for their innovations.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Patents and Publications",
  description:
    "Over the years, I have developed a knack for innovation and have been granted patents for my work. I have also published papers in Rotorcraft Conferences based on my Master's Thesis. ",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "0",
      name: "Searchlight auto-land system",
      createdAt: "2021-01-19T16:26:54Z",
      description: "Patent granted for an auto-land system based on searchlight tracking",
      url:
        "https://patents.google.com/patent/US10894613B2/",
    },
    {
      id: "1",
      name: "Active gimbal stabilized aerial visual-inertial navigation system",
      createdAt: "2022-02-24T16:26:54Z",
      description: "Patent published for a gimbal stabilized visual-inertial navigation system",
      url:
        "https://patents.google.com/patent/US20220060628A1/en",
    },
    {
      id: "2",
      name: "System and method for localization of safe zones in dense depth and landing quality heatmaps",
      createdAt: "2023-03-15T16:26:54Z",
      description: "Patent published for a system to localize safe landing zones in dense depth and landing quality heatmaps",
      url:
        "https://patents.google.com/patent/EP4148704A1/en",
    },
    {
      id: "3",
      name: "Modelling and analysis of a coaxial tiltrotor",
      createdAt: "2015-08-06T16:26:54Z",
      description: "Published paper on modelling and analysis of a coaxial tiltrotor in 4th Asian/Australian rotorcraft forum",
      url:
        "https://scholar.google.com/scholar?oi=bibs&cluster=7632911339214875936&btnI=1&hl=en",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "self.jpg",
    description:
      "Fuelled by a passion for robotics and deep learning, I'm always open to engaging conversations, innovative collaborations, and fresh opportunities. Feel free to reach out!",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blogs.rawnam.github.io/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "HSR Layout, Bengaluru, Karnataka - 560102",
    locality: "HSR Layout",
    country: "IN",
    region: "Karnataka",
    postalCode: "560102",
    streetAddress: "HSR Layout",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/nurbTH1iZbffyf9F7",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
